

















































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator"
import { UserModule } from "../../store/modules/user"
import VDistpicker from "v-distpicker"
import { log } from "console"
import { join } from "path"
import {
  getAirMonthWorkTime,
  getAirOrgTemplates,
  getTemplateIdByOrg,
  deleteTemplateOrg,
  addAirMonthTemplate,
  addAirOrgDayTime,
  addAirTemplateMonths,
  addTemplateOrg,
  getAirTemplateById,
  updateAirOrgDayTime,
  updateTemplateOrg,
  updateAirOrgTemplateMonths,
  getOrgAirCustom,
  getFilterHolidayWeekend,
  upDatefilterHolidyWeekend,
  setElementConfig,
  listElementConfigs,
} from "../../api/modules/user"
import {getCityInfoList,getListByType,getComfortTem,saveComfortTem} from '../../api/modules/param'
// import { log } from "console"

import SelectRegion from '@/components/Select/SelectRegion.vue'
import ComfortTempSlider from '@/components/ComfortTempSlider.vue'

@Component({
  components: { VDistpicker, SelectRegion, ComfortTempSlider },
})
export default class AccountInfo extends Vue {
  @Watch("worktime")
  onChangeValue(newVal: string, oldVal: string) {
    if (this.checked1) {
      let worktime = this.getIntervalHour(this.worktime[0], this.worktime2[1])
      // console.log(worktime);
      this.form.workTime = worktime
    } else {
      this.form.workTime = JSON.parse(JSON.stringify(this.formbf.workTime))
    }
    if (
      new Date(this.worktime[1]).getTime() >
      new Date(this.worktime2[0]).getTime()
    ) {
      this.worktime2[0] = this.worktime[1]
    }
    // console.log(`${oldVal}-> change -> ${newVal}`);

    // this.WatchText = `${oldVal}-> change -> ${newVal}`;
  }
  @Watch("worktime2")
  onChangeValue2(newVal: string, oldVal: string) {
    if (this.checked1) {
      let worktime = this.getIntervalHour(this.worktime[0], this.worktime2[1])
      // console.log(worktime);
      this.form.workTime = worktime
    } else {
      this.form.workTime = JSON.parse(JSON.stringify(this.formbf.workTime))
    }
    if (
      new Date(this.worktime2[0]).getTime() <
      new Date(this.worktime[1]).getTime()
    ) {
      this.worktime2[0] = this.worktime[1]
    }
    // console.log(`${oldVal}-> change -> ${newVal}`);

    // this.WatchText = `${oldVal}-> change -> ${newVal}`;
  }
  pickeroptions: any = {
    disabledDate: (time: any) => {
      //return '13:00:00'
    },
    // console.log(1) // 打印结果如下，time打印结果为日期组件中的所有时间

    // form:any={}
  }
  checked1: boolean = false
  checkboxGroup1: any[] = []
  dynamicTags: any[] = []
  inputVisible: boolean = false
  inputValue: any = ""
  tempTag: any = ""
  radiokt: any = "1"
  addmoba: boolean = false
  zdyWorkTime: any[] =[
             {
            "month": 1,
            "workTime": 3.0
        },
        {
            "month": 2,
            "workTime": 3.0
        },
        {
            "month": 3,
            "workTime": 4.0
        },
        {
            "month": 4,
            "workTime": 10.0
        },
        {
            "month": 5,
            "workTime": 13.0
        },
        {
            "month": 6,
            "workTime": 13.0
        },
        {
            "month": 7,
            "workTime": 13.0
        },
        {
            "month": 8,
            "workTime": 13.0
        },
        {
            "month": 9,
            "workTime": 13.0
        },
        {
            "month": 10,
            "workTime": 13.0
        },
        {
            "month": 11,
            "workTime": 8.0
        },
        {
            "month": 12,
            "workTime": 6.0
        }



         ]
  nohavetemple: boolean = true
  mobanWorkTime: any[] = []
  addxs: boolean = false
  addmobanWorkTime: any[] = []
  addmobaninput: string = ""
  isnozdy: boolean=false
  // 是否是重复数据
  isRepeatedData: boolean = false
  // 是否改变原来的值
  isChange: boolean = false
  dialogVisible: boolean = false

  options: any = [
    {
      value: "选项1",
      label: "黄金糕",
    },
    {
      value: "选项2",
      label: "双皮奶",
    },
    {
      value: "选项3",
      label: "蚵仔煎",
    },
    {
      value: "选项4",
      label: "龙须面",
    },
    {
      value: "选项5",
      label: "北京烤鸭",
    },
  ]
  value: any = ""
  valuex: any = ""
  orgid: any = ""
  valuetime: any=''
  vipStartDate:any=''
   weekdayfilter: any="0"
   hoildyfilter: boolean=false
   selectedCountry: string = ''
   countryList: any[] = []
   alarmEnabled: boolean = false
   alarmScope: string = '0'
   highTempAlarmThreshold: number = 30
   lowTempAlarmThreshold: number = 18
   warningNetGroupList: any[] = []
   selectedRooms: any[] = []
   comfortTempEnabled: boolean = false
   comfortTempValues: number[] = [20, 22, 26, 28]
   radarRebootHour: string = ''





  form: any = {
    orgId: "", //公司id、
    orgName: UserModule.orgInfo.name, //公司名称
    isSocketPush: false, //插座报告推送
    isSocketExpowerPush: false, //插座高功率推送
    worktime: [new Date(2016, 9, 10, 9, 0), new Date(2016, 9, 10, 12, 0)], //上下班时间
    worktime2: [new Date(2016, 9, 10, 13, 30), new Date(2016, 9, 10, 18, 0)], //上下班时间

    weekdayType: "1", //周末休息1：双休，3：其他,2:单休，0：无

    beginTime: "",
    endTime: "",
    //worktime: [new Date(2016, 9, 10, 9, 0), new Date(2016, 9, 10, 18, 30)], //上下班时间
    //  weekdayType: "1", //周末休息1：双休，3：其他,2:单休，0：无

    exPowerValue: 1, //插座高功率推送阈值
    city: "深圳",
    postion: "深圳",
    province: "广东",
    countryCode:'CN'
  }
  formbf: any = {
    orgId: "", //公司id、
    orgName: UserModule.orgInfo.name, //公司名称
    isSocketPush: false, //插座报告推送
    isSocketExpowerPush: false, //插座高功率推送
    worktime: [new Date(2016, 9, 10, 9, 0), new Date(2016, 9, 10, 12, 0)], //上下班时间
    worktime2: [new Date(2016, 9, 10, 13, 30), new Date(2016, 9, 10, 18, 0)], //上下班时间

    weekdayType: "1", //周末休息1：双休，3：其他,2:单休，0：无

    beginTime: "",
    endTime: "",
    //worktime: [new Date(2016, 9, 10, 9, 0), new Date(2016, 9, 10, 18, 30)], //上下班时间
    //  weekdayType: "1", //周末休息1：双休，3：其他,2:单休，0：无

    exPowerValue: 1, //插座高功率推送阈值
    city: "深圳",
    postion: "深圳",
    province: "广东",
    countryCode:'CN'
  }

  select: any = { province: "", city: "",cityName:"" }

  worktime: any[] = [new Date(2016, 9, 10, 9, 0), new Date(2016, 9, 10, 12, 0)]
  worktime2: any[] = [
    new Date(2016, 9, 10, 13, 30),
    new Date(2016, 9, 10, 18, 0),
  ]

  private handleClose(tag: any) {
    this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    // this.form.orgEmail=this.dynamicTags.join(';')
    // console.log(this.form.orgEmail);
  }
  private handleCloses(done: any) {
    done()
  }

  private handleProvinceChange(val: any) {
    console.log(val);
    
    this.select.province = val.value
    this.form.province = val.value
    this.form.city = ""
    this.form.cityName = ""
  }
  private handleCityChange(val: any) {
    this.select.city = val.value
    this.form.city = val.value
    this.form.cityName = ""
  }
  private handleAreaChange(val: any) {
    this.form.cityName = val.value
  }


  private changemoban(e: any) {
    console.log(e)
    let tid
    for (let i = 0; i < this.options.length; i++) {
      if (this.options[i].value == e) {
        tid = this.options[i].templateId
      }
    }
    console.log(tid)
    // let data
    getAirTemplateById({ templateId: tid }).then((res) => {
      console.log(res)
      this.mobanWorkTime = res
    })
  }
  private changemobans(e: any) {
    console.log(e)
    let tid
    for (let i = 0; i < this.options.length; i++) {
      if (this.options[i].value == e) {
        tid = this.options[i].templateId
      }
    }
    console.log(tid)
    // let data
    getAirTemplateById({ templateId: tid }).then((res) => {
      console.log(res)
      if (res.length == 12) {
        this.addmobanWorkTime = res
        this.addxs = true
      } else {
        this.addxs = false
        this.addmobanWorkTime = [
          { month: 1, workTime: 0 },
          { month: 2, workTime: 0 },
          { month: 3, workTime: 0 },
          { month: 4, workTime: 0 },
          { month: 5, workTime: 0 },
          { month: 6, workTime: 0 },
          { month: 7, workTime: 0 },
          { month: 8, workTime: 0 },
          { month: 9, workTime: 0 },
          { month: 10, workTime: 0 },
          { month: 11, workTime: 0 },
          { month: 12, workTime: 0 },
        ]
      }
    })
  }
  private updmoban() {
    // console.log(this.value)
    let tid
    for (let i = 0; i < this.options.length; i++) {
      if (this.options[i].value == this.valuex) {
        tid = this.options[i].templateId
      }
    }
    console.log(tid)

    let data = {
      airTemplateTimeList: this.addmobanWorkTime,
      templateId: tid,
    }
    if (this.addxs) {
      updateAirOrgTemplateMonths(data).then((res) => {
        console.log(res)
        this.$message({
          type: "success",
          message: "修改成功",
        })
      })
    } else {
      addAirTemplateMonths(data).then((res) => {
        console.log(res)
        this.addxs = true
        this.$message({
          type: "success",
          message: "修改成功",
        })
      })
    }

    // add
  }

  private addmoban() {
    let that = this
    if (this.addmobaninput) {
      let data = {
        // airTemplateAddVO:{
        templateName: this.addmobaninput,
        // }
      }
      addAirMonthTemplate(data).then((res) => {
        console.log(res)

        this.$message({
          type: "success",
          message: "添加成功",
        })
        that.addmobaninput = ""
        getAirOrgTemplates().then((res) => {
          console.log(res)
          that.options = res.airTemplates
          for (let i = 0; i < that.options.length; i++) {
            that.options[i]["text"] = that.options[i].templateId
            that.options[i]["value"] = that.options[i].templateName
          }
        })
      })
    } else {
      this.$message({
        type: "error",
        message: "请输入模板名称",
      })
    }
  }

  private addmb() {
    this.addmoba = true
  }
  private controlmb() {
    this.addmoba = false
  }
  private showInput() {
    this.inputVisible = true
    this.tempTag = ""
    this.inputValue = ""
    this.isChange = false

    this.$nextTick((_) => {
      this.$refs.saveTagInput.$refs.input.focus()
    })
  }

  private handleInputConfirm() {
    let inputValue = this.inputValue
    if (inputValue) {
      //  /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      let pat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      // if()
      if (pat.test(inputValue)) {
        this.dynamicTags.push(inputValue)
      } else {
        this.$message({
          type: "error",
          message: "请输入正确的邮箱",
        })
      }
    }

    this.inputVisible = false
    this.inputValue = ""
  }

  private Timecl(str: string) {
    //时间处理
    let arr = ["2016", "9", "10"]
    let strs = "2015-03-05 " + str
    // console.log(strs);

    //let dateStr = strs.substring(0,19);
    //dateStr = dateStr.replace(/-/g,'/');
    var timeTamp = new Date(strs)

    // console.log(timeTamp);
    // console.log(new Date(2016, 9, 10, 9, 0));

    return timeTamp
  }
  private get userInfo() {
    // console.log(UserModule.userInfo)

    return UserModule.userInfo
  }
  private get orgInfo() {
    // console.log(UserModule.userInfo)
    return UserModule.orgInfo
  }
  private getcreat() {
    this.orgid = UserModule.orgInfo.orgId
    console.log(this.orgid)
    let that = this
       getFilterHolidayWeekend({ orgId: this.orgid }).then((ress)=>{
      console.log(ress);
      that.valuetime=ress.staticFromDate
      if(ress.isFilterLegalHoliday==1){
        that.hoildyfilter=true

      }else{
        that.hoildyfilter=false
      }
        if(ress.isFilterSunday==1){
        that.weekdayfilter=1
      }
          if(ress.isFilterWeekend==1){
        that.weekdayfilter=0

      }
        if(ress.isFilterWeekend==0&&ress.isFilterSunday==0){
        that.weekdayfilter=2

      }
    
      
    })
    getAirOrgTemplates().then((res) => {
      console.log(res)
      that.options = res.airTemplates
      for (let i = 0; i < that.options.length; i++) {
        that.options[i]["text"] = that.options[i].templateId
        that.options[i]["value"] = that.options[i].templateName
      }

      getTemplateIdByOrg({ orgId: this.orgid }).then((res) => {
        console.log(res)
        if (res.templateId) {
          this.nohavetemple = false
          this.radiokt = "2"
          let va
          for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].templateId == res.templateId) {
              va = this.options[i].templateName
            }
          }
          // console.log(tid)
          this.value = va
          getAirTemplateById({ templateId: res.templateId }).then((res) => {
            console.log(res)
            this.mobanWorkTime = res
          })
        } else {
          this.nohavetemple = true
          this.radiokt = "1"
        }
      })
    })
      getOrgAirCustom({ orgId: this.orgid }).then((res)=>{
        console.log(res);
        if(res.length==0){
          this.isnozdy=true
        }else{
           this.isnozdy=false
        }
        
      })

    getAirMonthWorkTime({ orgId: this.orgid }).then((res) => {
      console.log(res)
      if(JSON.stringify(res)=='[]'){
         that.zdyWorkTime=[
             {
            "month": 1,
            "workTime": 3.0
        },
        {
            "month": 2,
            "workTime": 3.0
        },
        {
            "month": 3,
            "workTime": 4.0
        },
        {
            "month": 4,
            "workTime": 10.0
        },
        {
            "month": 5,
            "workTime": 13.0
        },
        {
            "month": 6,
            "workTime": 13.0
        },
        {
            "month": 7,
            "workTime": 13.0
        },
        {
            "month": 8,
            "workTime": 13.0
        },
        {
            "month": 9,
            "workTime": 13.0
        },
        {
            "month": 10,
            "workTime": 13.0
        },
        {
            "month": 11,
            "workTime": 8.0
        },
        {
            "month": 12,
            "workTime": 6.0
        }



         ]

      }else{
          that.zdyWorkTime = res
      }
    
    })

    // console.log(
    //   UserModule.getOrgParam().then((res) => {
    //     console.log(res)
    //     this.form = res
    //     this.worktime=[this.Timecl(this.form.beginTime),this.Timecl(this.form.endTime)]
    //     //this.Timecl(res.beginTime)

    //   })
    // )
    // this.getorgparam()
  }

  created() {
    // console.log(this.)
    this.orgid = UserModule.orgInfo.orgId

    getListByType({type:'LIST_COUNTRIES'}).then((res)=>{
      console.log(res);
      this.countryList = res;
      // 设置默认选中中国
      const china = res.find((item: any) => item.name === 'CN');
      if (china && !this.selectedCountry) {
        this.selectedCountry = china.name;
      }
    })
    // console.log(this.orgid)
    let that = this
      getFilterHolidayWeekend({ orgId: this.orgid }).then((ress)=>{
      // console.log(ress);
      that.valuetime=ress.staticFromDate
      if(ress.isFilterLegalHoliday==1){
        that.hoildyfilter=true

      }else{
        that.hoildyfilter=false
      }
        if(ress.isFilterSunday==1){
        that.weekdayfilter=1
      }
          if(ress.isFilterWeekend==1){
        that.weekdayfilter=0

      }
        if(ress.isFilterWeekend==0&&ress.isFilterSunday==0){
        that.weekdayfilter=2

      }
    
      
    })
    getAirOrgTemplates().then((res) => {
      // console.log(res)
    
      that.options = res.airTemplates
      for (let i = 0; i < that.options.length; i++) {
        that.options[i]["text"] = that.options[i].templateId
        that.options[i]["value"] = that.options[i].templateName
      }

      getOrgAirCustom({ orgId: this.orgid }).then((res)=>{
        // console.log(res);
        if(res.length==0){
          this.isnozdy=true
        }else{
           this.isnozdy=false
        }
        
      })

      getTemplateIdByOrg({ orgId: this.orgid }).then((res) => {
        // console.log(res)
        if (res.templateId) {
          this.nohavetemple = false
          this.radiokt = "2"
          let va
          for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].templateId == res.templateId) {
              va = this.options[i].templateName
            }
          }
          // console.log(tid)
          this.value = va
          getAirTemplateById({ templateId: res.templateId }).then((res) => {
            console.log(res)
            this.mobanWorkTime = res
          })
        } else {
          this.nohavetemple = true
          this.radiokt = "1"
        }
      })
    })

    getAirMonthWorkTime({ orgId: this.orgid }).then((res) => {
      // console.log(res)
         if(JSON.stringify(res)=='[]'){
         that.zdyWorkTime=[
             {
            "month": 1,
            "workTime": 3.0
        },
        {
            "month": 2,
            "workTime": 3.0
        },
        {
            "month": 3,
            "workTime": 4.0
        },
        {
            "month": 4,
            "workTime": 10.0
        },
        {
            "month": 5,
            "workTime": 13.0
        },
        {
            "month": 6,
            "workTime": 13.0
        },
        {
            "month": 7,
            "workTime": 13.0
        },
        {
            "month": 8,
            "workTime": 13.0
        },
        {
            "month": 9,
            "workTime": 13.0
        },
        {
            "month": 10,
            "workTime": 13.0
        },
        {
            "month": 11,
            "workTime": 8.0
        },
        {
            "month": 12,
            "workTime": 6.0
        }



         ]

      }else{
          that.zdyWorkTime = res
      }
    })
    
    // 加载舒适温度配置
    getComfortTem(this.orgid).then((res: any) => {
      if (res && res.valueList && res.valueList.length === 4) {
        this.comfortTempValues = res.valueList
        this.comfortTempEnabled = res.switchStatus === 1
      }
    }).catch(() => {
      // 如果接口失败，使用默认值
    })
    
    // 加载雷达网关重启时间配置
    listElementConfigs({
      orgId: this.orgid,
      scopeType: 'ORG_TYPE',
      prodTypeCode: 'gatewayradar',
      elementKey: '5026',
      pageNo: 1,
      pageSize: 20
    }).then((res: any) => {
      if (res && res.list && res.list.length > 0) {
        this.radarRebootHour = res.list[0].elementValue
      }
    }).catch(() => {
      // 加载失败，使用默认值
    })
    // console.log(
    //   UserModule.getOrgParam().then((res) => {
    //     console.log(res)
    //     this.form = res
    //     this.worktime=[this.Timecl(this.form.beginTime),this.Timecl(this.form.endTime)]
    //     //this.Timecl(res.beginTime)

    //   })
    // )
    this.getorgparam()
  }
  private getorgparam() {
    UserModule.getOrgParam().then((res) => {
      console.log(res);
      
      this.form = res
      this.formbf = JSON.parse(JSON.stringify(res))
      this.dynamicTags = this.form.orgEmail.split(";")
      let arr = this.form.isSocketPush.split(",")
      if (arr[0] == "1") {
        this.checkboxGroup1.push("1")
      }
      if (arr[1] == "1") {
        this.checkboxGroup1.push("2")
      }
      if (arr[2] == "1") {
        this.checkboxGroup1.push("3")
      }

      if (this.form.beginTime) {
        this.worktime = [
          this.Timecl(this.form.beginTime.split("-")[0]),
          this.Timecl(this.form.beginTime.split("-")[1]),
        ]
        this.worktime2 = [
          this.Timecl(this.form.endTime.split("-")[0]),
          this.Timecl(this.form.endTime.split("-")[1]),
        ]
      }
      if (this.form.isSocketPush == 1) {
        this.form.isSocketPush = true
      } else {
        this.form.isSocketPush = false
      }
      if (this.form.isSocketExpowerPush == 1) {
        this.form.isSocketExpowerPush = true
      } else {
        this.form.isSocketExpowerPush = false
      }
      this.vipStartDate = this.form.vipStartDate

      this.select.province = this.provincetamp(this.form.province)
      this.select.city = this.form.city
      this.select.cityName = this.form.cityName

      this.selectedCountry = this.form.countryCode
      
      // 加载温度告警设置
      this.alarmEnabled = res.alarmEnabled === 1
      this.alarmScope = String(res.alarmScope || 0)
      this.highTempAlarmThreshold = res.highTempAlarmThreshold || 30
      this.lowTempAlarmThreshold = res.lowTempAlarmThreshold || 18
      this.warningNetGroupList = res.warningNetGroupList || []
      // 转换为SelectRegion所需格式（等待组织树加载完成）
      if (this.warningNetGroupList.length > 0) {
        // 如果组织树已加载，直接转换
        if (UserModule.orgPosList.length > 0) {
          this.selectedRooms = this.convertToSelectedRooms(this.warningNetGroupList)
        } else {
          // 组织树未加载，等待加载后再转换
          const checkOrgPosList = setInterval(() => {
            if (UserModule.orgPosList.length > 0) {
              this.selectedRooms = this.convertToSelectedRooms(this.warningNetGroupList)
              clearInterval(checkOrgPosList)
            }
          }, 100)
          // 10秒超时
          setTimeout(() => clearInterval(checkOrgPosList), 10000)
        }
      }
    })
  }
  private updorgparam() {
    //  console.log(this.form);
    // for(let i=0;i<this.checkboxGroup1.length;i++){
    //   if()
    // }
    let st1 = this.checkboxGroup1.includes("1")
    let st2 = this.checkboxGroup1.includes("2")
    let st3 = this.checkboxGroup1.includes("3")
    let str4 = Number(st1) + "," + Number(st2) + "," + Number(st3)

    this.form.isSocketPush = str4

    // if (this.form.isSocketPush) {
    //   this.form.isSocketPush = 1
    // } else {
    //   this.form.isSocketPush = 0
    // }
    if (this.form.isSocketExpowerPush) {
      this.form.isSocketExpowerPush = 1
    } else {
      this.form.isSocketExpowerPush = 0
    }
    this.form.beginTime = this.timestampToTime(this.worktime[0])
    this.form.endTime = this.timestampToTime(this.worktime[1])

    UserModule.updOrgParam(this.form).then((res) => {
      //  console.log(res);
      this.getorgparam()
    })
  }
  private setchanger(e: any) {
    console.log(e)
    if (e) {
      let worktime = this.getIntervalHour(this.worktime[0], this.worktime2[1])
      // console.log(worktime);
      this.form.workTime = worktime
    } else {
      this.form.workTime = JSON.parse(JSON.stringify(this.formbf.workTime))
    }
  }
  private changes(e: any) {
    console.log(e)
    let st1 = this.checkboxGroup1.includes("1")
    let st2 = this.checkboxGroup1.includes("2")
    let st3 = this.checkboxGroup1.includes("3")
    let str4 = Number(st1) + "," + Number(st2) + "," + Number(st3)

    console.log(str4)
  }
  private getIntervalHour(startDate: any, endDate: any) {
    var ms = endDate.getTime() - startDate.getTime()
    if (ms < 0) return 0
    return (ms / 1000 / 60 / 60).toFixed(1)
  }
private formatDate(date:any) {
  let year = date.getFullYear(),
    month = date.getMonth() + 1,
    day = date.getDate();
  return `${year}-${month < 10 ? '0' + month : month}-${
    day < 10 ? '0' + day : day
  }`;
}
  private inputwork(e: any) {
    if (e > 24) {
      this.form.workTime = 24
    }
  }
  private onSubmit() {
    console.log(this.form.cityName);
    
    if(this.form.cityName==''){
      this.$message({
        type: "error",
        message: "请选择城市",
      })
      return
    }
    this.$confirm("是否进行修改, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        let st1 = this.checkboxGroup1.includes("1")
        let st2 = this.checkboxGroup1.includes("2")
        let st3 = this.checkboxGroup1.includes("3")
        let str4 = Number(st1) + "," + Number(st2) + "," + Number(st3)

        this.form.orgEmail = this.dynamicTags.join(";")
        this.form.isSocketPush = str4
        if (this.form.isSocketExpowerPush) {
          this.form.isSocketExpowerPush = 1
        } else {
          this.form.isSocketExpowerPush = 0
        }
        this.form.beginTime =
          this.timestampToTime(this.worktime[0]) +
          "-" +
          this.timestampToTime(this.worktime[1])
        this.form.endTime =
          this.timestampToTime(this.worktime2[0]) +
          "-" +
          this.timestampToTime(this.worktime2[1])
        this.form.province = this.tampprovince(this.form.province)
        if (this.radiokt == 1) {
          let data = {
            monthWorkTimes: this.zdyWorkTime,
            orgId: this.orgid,
          }
          if(!this.isnozdy){
  if (this.nohavetemple) {
            updateAirOrgDayTime(data).then((res) => {
              console.log(res)
              this.getcreat()
            })
          } else {
            deleteTemplateOrg({ orgId: this.orgid }).then((res) => {
              updateAirOrgDayTime(data).then((res) => {
                console.log(res)
                this.getcreat()
              })
            })
          }
          }else{
               if (this.nohavetemple) {
                
            addAirOrgDayTime(data).then((res) => {
              console.log(res)
              this.getcreat()
            })
          } else {
            deleteTemplateOrg({ orgId: this.orgid }).then((res) => {
              addAirOrgDayTime(data).then((res) => {
                console.log(res)
                this.getcreat()
              })
            })
          }

          }
       
        }
        if (this.radiokt == 2) {
          let tid
          for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].value == this.value) {
              tid = this.options[i].templateId
            }
          }
          console.log(tid)

          if (this.nohavetemple) {
            addTemplateOrg({ orgId: this.orgid, templateId: tid }).then(
              (res) => {
                console.log(res)
                this.getcreat()
              }
            )
          } else {
            updateTemplateOrg({ orgId: this.orgid, templateId: tid }).then(
              (res) => {
                console.log(res)
                this.getcreat()
              }
            )
          }
        }
        console.log(this.valuetime);
         let strdate=''
        if(this.valuetime!=''){
  strdate= this.formatDate(new Date(this.valuetime))
        }else{
          strdate= '2019-01-01'
        }
    
        console.log(strdate);
        
        let datas={
          orgId:this.orgid,
          filterWeekend:1,
          filterSunday:0,
          fromDate:strdate,
          isFilterLegalHoliday:this.hoildyfilter?'1':'0'


        }
        if(this.weekdayfilter==0){
          datas.filterWeekend=1
          datas.filterSunday=0

        }
           if(this.weekdayfilter==1){
          datas.filterWeekend=0
          datas.filterSunday=1

        }
           if(this.weekdayfilter==2){
          datas.filterWeekend=0
          datas.filterSunday=0

        }
        upDatefilterHolidyWeekend(datas).then((res)=>{
          console.log(res);
             this.getcreat()
          
        })
        this.form.postion = this.form.city.replace(/,/g, "市")
        this.form.vipStartDate =this.formatDate(new Date(this.vipStartDate),'YYYY-MM-DD')  
        this.form.countryCode=this.selectedCountry
        
        // 添加温度告警参数
        this.form.alarmEnabled = this.alarmEnabled ? 1 : 0
        this.form.alarmScope = Number(this.alarmScope)
        this.form.highTempAlarmThreshold = this.highTempAlarmThreshold
        this.form.lowTempAlarmThreshold = this.lowTempAlarmThreshold
        if (this.alarmScope === '1' && this.selectedRooms.length === 0) {
          this.$message({
            type: "error",
            message: "指定房间模式必须选择至少一个房间",
          })
          return
        }
        this.form.warningNetGroupList = this.convertFromSelectedRooms(this.selectedRooms)
        
        // 保存舒适温度配置
        if (this.comfortTempEnabled) {
          const comfortTempData = {
            orgId: this.orgid,
            valueList: this.comfortTempValues,
            switchStatus: 1
          }
          saveComfortTem(comfortTempData).catch(() => {
            // 忽略错误，不影响主流程
          })
        } else {
          // 关闭状态
          const comfortTempData = {
            orgId: this.orgid,
            valueList: this.comfortTempValues,
            switchStatus: 0
          }
          saveComfortTem(comfortTempData).catch(() => {})
        }
        
        // 保存雷达网关重启时间配置
        if (this.radarRebootHour !== '') {
          const elementData = {
            orgId: this.orgid,
            scopeType: 'ORG_TYPE' as const,
            prodTypeCode: 'gatewayradar',
            elementKey: '5026',
            elementValue: this.radarRebootHour
          }
          setElementConfig(elementData).catch(() => {
            // 忽略错误，不影响主流程
          })
        }
        
        UserModule.updOrgParam(this.form).then((res) => {
          //  console.log(res);
          this.getorgparam()

          this.$message({
            type: "success",
            message: "修改成功!",
          })
        })
      })
      .catch((err) => {
        console.log('err',err);
        
        this.$message({
          type: "error",
          message: "请检查是否有参数未填",
        })
      })
    //提交

    //console.log(this.form)
  }
  private onSelected(data: any) {
    // alert(data.province + ' | ' + data.city + ' | ' + data.area)
    console.log(data)
    this.form.province = this.provincetamp(data.province.value)
    this.form.city = data.city.value
    this.form.cityName=data.area.value
    if(data.province.value=='北京市' || data.province.value=='天津市' || data.province.value=='上海市'){


      getCityInfoList({ administrativeOwnership: data.city.value+'/'+data.area.value }).then((res) => {
      console.log(res)
      if(res.length==1){
      this.form.cityId=res[0].cityId


      }
      else{
    getCityInfoList({ administrativeOwnership: data.city.value }).then((ress) => {
      console.log(ress)
      this.form.cityId=ress[0].cityId
    })

      }
      // this.form.cityName = res.cityName
    })
    }else{

   
    getCityInfoList({ administrativeOwnership:data.province.value+'/'+ data.city.value+'/'+data.area.value }).then((res) => {
      console.log(res)
      if(res.length==1){
      this.form.cityId=res[0].cityId


      }
      else{
    getCityInfoList({ administrativeOwnership:data.province.value+'/'+ data.city.value }).then((ress) => {
      console.log(ress)
      this.form.cityId=ress[0].cityId
    })

      }
      // this.form.cityName = res.cityName
    })
  }
    // console.log(this.form);
  }
  // 时间格式化
  private timestampToTime(chinaStandard: any) {
    // var chinaStandard=Mon Jul 19 2021 11:11:55 GMT+0800 (中国标准时间);
    var date = new Date(chinaStandard)
    var y: any = date.getFullYear()
    var m: any = date.getMonth() + 1
    m = m < 10 ? "0" + m : m
    var d: any = date.getDate()
    d = d < 10 ? "0" + d : d
    var h = date.getHours()
    var minute: any = date.getMinutes()
    minute = minute < 10 ? "0" + minute : minute
    var second: any = date.getSeconds()
    second = second < 10 ? "0" + second : second
    let Time = y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second
    // console.log(Time);
    let arr = []
    arr = Time.split(" ")
    // console.log(arr[1]);

    return arr[1]
  }

  //省份格式化
  private tampprovince(str: string) {
    if (str == "内蒙古自治区") {
      return "内蒙古"
    } else if (str == "黑龙江省") {
      return "黑龙江"
    } else if (str == "广西壮族自治区") {
      return "广西"
    } else if (str == "西藏自治区") {
      return "西藏"
    } else if (str == "宁夏回族自治区") {
      return "宁夏"
    } else if (str == "新疆维吾尔自治区") {
      return "新疆"
    } else if (str == "香港特别行政区") {
      return "香港"
    } else if (str == "澳门特别行政区") {
      return "澳门"
    } else if (str == "海外") {
      return "海外"
    } else {
      return str.substr(0, 2)
    }
  }

  //逆省份格式化
  private provincetamp(str: string) {
    if (str == "内蒙古") {
      return "内蒙古自治区"
    } else if (str == "黑龙江") {
      return "黑龙江省"
    } else if (str == "广西") {
      return "广西壮族自治区"
    } else if (str == "西藏") {
      return "西藏自治区"
    } else if (str == "宁夏") {
      return "宁夏回族自治区"
    } else if (str == "新疆") {
      return "新疆维吾尔自治区"
    } else if (str == "香港") {
      return "香港特别行政区"
    } else if (str == "澳门") {
      return "澳门特别行政区"
    } else if (str == "海外") {
      return "海外"
    } else if (str == "北京") {
      return "北京市"
    } else if (str == "天津") {
      return "天津市"
    } else if (str == "上海") {
      return "上海市"
    } else {
      return str + "省"
    }
  }

  //取得的值 2021-07-19 11:11:55

  private onDefault() {
    this.getorgparam()
  }
  
  private handleRoomChange(selection: any) {
    console.log('房间选择变化:', selection)
  }
  
  private handleTempChange(values: number[]) {
    // 温度滑块变化回调
  }
  
  private convertToSelectedRooms(warningList: any[]): any[] {
    // 将后端数据格式 [{netId, groupId}] 转换为SelectRegion格式 [[posId1, posId2, posId3, netId, groupId]]
    const result: any[] = []
    for (const item of warningList) {
      const { netId, groupId } = item
      const posIdList = this.findPosIdListByNetId(netId)
      if (posIdList.length > 0) {
        result.push([...posIdList, netId, groupId])
      }
    }
    return result
  }
  
  private convertFromSelectedRooms(selectedRooms: any[]): any[] {
    // 将SelectRegion格式 [[posId1, posId2, posId3, netId, groupId]] 转换为后端格式 [{netId, groupId}]
    const result: any[] = []
    for (const item of selectedRooms) {
      const netId = item[3]
      const groupId = item[4]
      result.push({ netId, groupId })
    }
    return result
  }
  
  private findPosIdListByNetId(netId: string): any[] {
    // 递归查找netId对应的posIdList路径（栋、层、区三级）
    const findPath = (nodes: any[], path: any[] = []): any[] | null => {
      for (const node of nodes) {
        // level 0-栋, 1-层, 2-区, 3-网络, 4-组
        if (node.level === 3 && node.id === netId) {
          // 找到网络节点，返回其父级路径（前三级：栋、层、区）
          return path
        }
        if (node.children && node.children.length > 0) {
          const found = findPath(node.children, [...path, node.id])
          if (found) return found
        }
      }
      return null
    }
    const result = findPath(UserModule.orgPosList)
    return result || []
  }
}
